import * as api from "./v1Endpoints"
import { apiV1Mock } from "./v1Mock"
export { apiV1Mock } from "./v1Mock"

export const apiV1 = import.meta.env.MODE === "test" ? apiV1Mock.mocks : api
